import React from 'react'
import _ from 'lodash'
import viewliftLogo from '~/assets/images/viewlift-logo.png'
import './Footer03.css'

import appStore from '~/assets/images/app-store-badge.svg'
import playStore from '~/assets/images/google-play-badge.png'
import { localizeTitle } from '../../tools/localization'

const getBadgeSrc = url =>
  url.includes('apple.com') ? appStore : url.includes('google.com') ? playStore : ''


class Footer03 extends React.Component {
  constructor(props) {
    super(props)

    this.address = _.get(window.settings, "navigation.settings.footerAddress");
    this.phone = _.get(window.settings, 'customerService.phone')
    this.bgImage = _.get(window.settings, 'navigation.settings.footerBackgroundImage')
  }

  formatPhoneNumber(s) {
    const s2 = (""+s).replace(/\D/g, '');
    const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return (!m) ? null : "(" + m[1] + ")" + m[2] + "-" + m[3];
  }

  render() {
    let footerBgStyle
    if (this.bgImage) {
      footerBgStyle = {
        background: `url(${this.bgImage}) no-repeat`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }
    }

    return (
      <footer style={ footerBgStyle } className="footer03 footer">
        <div className="site-info-section">
          <div className="site-info">
            { this.renderLogo() }
            { (this.address || this.phone) &&
              <div className="contact-info">
                { this.renderAddressSection() }
                { this.renderPhoneSection() }
              </div>
            }
          </div>
          { this.renderNetworks() }
        </div>
        <div className="link-section">
          { this.renderLinks() }
        </div>
        { this.renderMediaSection() }
        { this.renderCopySection() }
      </footer>
    )
  }
  
  renderLogo() {
    const logoSrc = 
      _.get(window.settings, 'navigation.settings.footerLogo') || 
      _.get(window.settings, 'images.desktopLogo')

    if (!logoSrc)
      return

    const backgroundLogoStyle = {
      background: `url(${logoSrc}) no-repeat`,
      backgroundSize: 'contain',
      backgroundPosition: 'top'
    }

    return <div className="logo" style={ backgroundLogoStyle }></div>
  }

  renderAddressSection() {
    if (!this.address) 
      return
    
    return (
      <div aria-label={`Address: ${this.address}`} tabIndex="0" className="address-section">
        <p className="site-info-label">Address</p>
        <div className="site-info-value">{ this.address }</div>
      </div>
    )
  }

  renderPhoneSection() {
    if (!this.phone) 
      return
    
    const phoneNum = this.formatPhoneNumber(this.phone)
    return (
      <div aria-label={`Phone number: ${phoneNum}`} tabIndex="0" className="phone-section">
        <p className="site-info-label">Phone</p>
        <p className="site-info-value">{ phoneNum }</p>
      </div>
    )
  }

  renderNetworks() {
    let networks = _.get(window.settings, 'navigation.network')
    if (!networks)
      return

    return (
      <div className="networks">
        <div className="label">Proud Home of The</div>
        <div className="network-links">
          { _.map(networks, (network, idx) => {

            let linkBgStyle = {
              background: `url(${network.icon}) no-repeat`,
              backgroundSize: 'contain',
              backgroundPosition: 'center'
            }

            return <a aria-label={network.title} style={ linkBgStyle } key={idx} href={ network.url }></a>
          })}
        </div>
      </div>
    )
  }

  renderLinks() {
    const links = _.get(window.settings, 'navigation.footer', [])

    return _.map(links, (link, idx) => (
      <div key={idx} className="footer-link">
        <a href={ link.url } target={ link.newTab ? "_blank" : "_self" }>{ link.title }</a>
        { (link.items && link.items.length > 0) &&
          this.renderSubLinkMenu(link.items)
        }
      </div>
    ))
  }

  renderSubLinkMenu = links => (
    <div className="sublink-menu">
      { _.map(links, (link, idx) => (
        <a key={idx} href={link.url} target={link.newTab ? "_blank" : "_self"}>{ localizeTitle(link) }</a>
      ))}
    </div>
  )

  renderMediaSection() {
    const socialMediaLinks = _.get(window.settings, 'socialMedia')
    const appLinks = _.get(window.settings, 'navigation.appStore')

    if (!socialMediaLinks && !appLinks)
      return

    return (
      <div className="media-section">
        { appLinks &&
          <div className="app-links">
            { _.map(appLinks, (link, index) => {
              let linkBgStyle = {
                background: `url(${ getBadgeSrc(link.url) }) no-repeat`,
                backgroundSize: 'contain',
                backgroundPosition: 'center'
              }
              
              return(
                <a 
                  style={ linkBgStyle } 
                  className="app-link" 
                  key={ index } 
                  href={ link.url } 
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={ link.title }
                >
                </a>
              )
            })}
          </div>
        }
        { socialMediaLinks &&
          <div className="social-links">
            { _.map(socialMediaLinks, (link, key) => (
              <a className="social-link" key={key} href={ link.url } aria-label={key} target="_blank" rel="noopener noreferrer">
                <i role="presentation" className={`ion-social-${key}`} />
              </a>
              ))
            }
          </div>
        }
      </div>
    )
  }

  renderCopySection = () => (
    <div className="copy-section">
      <div className="copyright">
        {`© ${new Date().getFullYear()} ${window.settings.companyName}. All rights reserved.`}
      </div>
      <a aria-label="Viewlift" className="viewlift" target="_blank" rel="noopener noreferrer" href="http://www.viewlift.com/">
        <span className="label">Powered by</span>
        {!window.SERVER_SIDE_RENDERING && <img src={viewliftLogo} alt="ViewLift" />}
      </a>
    </div>
  )
}

export default Footer03